import React, { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import { RoleContext } from "../../contexts/RoleContext";
import { AuthContext } from "../../contexts/AuthContext";
import Notification from "../../components/UI/Notification";
import RolePermissionsForm from "./components/RolePermissionsForm";
import { getRoleBasedRoute } from "../../utils/routeUtils";
import { FaArrowLeft } from "react-icons/fa";

const AddRole = () => {
  const { addRole, clearError } = useContext(RoleContext);
  const { roles: userRoles, token } = useContext(AuthContext);
  const [notification, setNotification] = useState(null);
  const navigate = useNavigate();

  const getRoleBasedRouteLocal = (route) => {
    if (!userRoles || userRoles.length === 0) return route;
    return getRoleBasedRoute(route, userRoles);
  };

  const handleCreateRoleWithPermissions = async (data) => {
    clearError();
    if (!data.name.trim()) {
      setNotification({ message: "Role name cannot be empty.", type: "error" });
      return;
    }

    // Transform granular permissions object into requested payload format
    // permissions: array of keys that are true
    // remove: array of keys that are false
    const permissionsArray = [];

    Object.entries(data.permissions || {}).forEach(([key, value]) => {
      if (value === true) {
        permissionsArray.push(key);
      }
    });

    const payload = {
      name: data.name,
      permissions: permissionsArray,
    };

    const response = await addRole(token, payload);

    if (response?.success === true) {
      navigate(getRoleBasedRouteLocal("/admin/roles"), {
        state: { successMessage: "Role created successfully." },
      });
    } else {
      setNotification({
        message: response?.message || "Failed to add role.",
        type: "error",
      });
    }
  };

  return (
    <div className="w-full">
      {notification && (
        <Notification
          message={notification.message}
          type={notification.type}
          onClose={() => setNotification(null)}
        />
      )}
      <div className="p-4 md:p-6 lg:p-8 max-w-[1500px] mx-auto">
        <button
          type="button"
          onClick={() => navigate(getRoleBasedRouteLocal("/admin/roles"))}
          className="flex items-center gap-2 text-gray-600 dark:text-gray-400 hover:text-blue-600 dark:hover:text-blue-400 font-medium mb-6 transition-colors group"
        >
          <FaArrowLeft className="group-hover:-translate-x-1 transition-transform" />
          Back to Roles
        </button>
        <h2 className="text-2xl font-bold text-gray-800 dark:text-white mb-6">
          Create New Role
        </h2>
        <RolePermissionsForm
          onSave={handleCreateRoleWithPermissions}
          onCancel={() => navigate(getRoleBasedRouteLocal("/admin/roles"))}
        />
      </div>
    </div>
  );
};

export default AddRole;
